// Single source of truth for outbound links and route tokens.

export const CALENDLY_URL = 'https://calendly.com/datagen-info/meet_and_greet';

export const CONTACT_EMAIL = 'info@datagen.com';

/**
 * Hidden-route tokens.
 *
 * The /onepager and /deck routes only render if the URL contains the
 * correct token. Anything else falls through to the landing page silently
 * (no 404, no redirect — so nobody knows the hidden routes exist).
 *
 * Share these URLs to let someone view the artifacts:
 *
 *   /onepager/<ONEPAGER_TOKEN>
 *   /deck/<DECK_TOKEN>
 *
 * To rotate, change the constants here and rebuild — old links instantly
 * stop working. (Anyone who has the JS bundle can grep these out, so
 * treat them as unguessable URLs, not real auth.)
 */
export const ONEPAGER_TOKEN = 'op-a10d9bb8daece5b1b5ca6b0a3e3e41d2';
export const DECK_TOKEN = 'dk-8d3e1bec58cf678cfa2c1dc3000183d8';
